export const replicateCartBase = ({ execute }) => async (cartId) => {
    return execute({
        method: "POST",
        uri: `/ctp/carts/${cartId}/replicate`,
    });
};
